import React from 'react';
import { JobRenderInfo } from '../../job.types';
import { InfoCardJob } from '../InfoCardJob/InfoCardJob';
import { ImagePreview } from '../../../../components/ImagePreview/ImagePreview';

interface JobRenderInfoListProps {
    items: JobRenderInfo[];
    getImageUrl: (image: string) => string;
    column?: boolean;
}

export const JobRenderInfoList: React.FC<JobRenderInfoListProps> = ({ items, getImageUrl, column }) => (
    <>
        {items.map((item) => (
            item.image ? (
                <ImagePreview key={item.title} title={item.title} url={getImageUrl(item.image)} />
            ) : (
                <InfoCardJob key={item.title} title={item.title} text={item.text} column={column} />
            )
        ))}
    </>
);
